<template>
<div v-if="images">
  <div class="wp-block-columns products__grid-single">
  <div class="wp-block-column"
      v-for="(img, key) in images"
      :key="key"
      :class="{'d-none': !imageKey(key)}">
    <a :href="img.image"
       :title="img.title"
       class="products__gallery lazyload"
       :data-bg="img.image"
       :data-sub-html="img.description">
    </a>
  </div>
  </div>

  <gallery-pagination @paginationUpdate="paginationUpdate" :paginationItems="paginationItems" :activeNumber="active"></gallery-pagination>
</div>
</template>

<script>
import GalleryPagination from "./GalleryPagination";
import deps from "../../depsloader";

export default {
  name: "GalleryPaginationApp",

  components: {
    GalleryPagination
  },

  data() {
    return {
      maxItems: 9,
      active: 0
    };
  },

  computed: {
    images() {
      return this.$root.images;
    },

    paginationItems() {
      return Math.ceil(this.images.length / this.maxItems);
    }
  },

  mounted() {
    deps.load("lightgallery").then(() => {
      lightGallery(this.$el, { // eslint-disable-line
        selector: "div.wp-block-column > a",
        thumbnail: false,
        download: false
      });
    });
  },

  methods: {
    imageKey(key) {
      const keyNumber = Math.floor(key / this.maxItems);
      if (keyNumber == this.active) {
        return true;
      }

      return false;
    },

    paginationUpdate(val) {
      this.active = val - 1;
    }
  }
}
</script>
